export const FLOOR_WARDEN = 'FLOOR_WARDEN'
export const FLOOR_WARDEN_EMERGENCY_RESPONSE_TEAM = 'FLOOR_WARDEN_EMERGENCY_RESPONSE_TEAM'
export const EMERGENCY_RESPONSE_TEAM = 'EMERGENCY_RESPONSE_TEAM'
